import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useUserRole } from "@/hooks/useUserRole";

/**
 * Sends an admin to /admin only on their first landing on the site
 * (root path right after signing in). Once they're navigating around,
 * they can freely visit any public page — no more forced redirects.
 *
 * Uses sessionStorage so the auto-redirect happens at most once per session.
 */
const AdminLockGuard = () => {
  const { user, loading: authLoading } = useAuth();
  const { isAdmin, isLoading: roleLoading } = useUserRole();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (authLoading || roleLoading) return;
    if (!user || !isAdmin) return;

    const already = sessionStorage.getItem("admin-landed");
    if (already) return;

    // Only auto-redirect from "/" — never hijack other intentional navigation.
    if (location.pathname === "/") {
      sessionStorage.setItem("admin-landed", "1");
      navigate("/admin", { replace: true });
    } else {
      sessionStorage.setItem("admin-landed", "1");
    }
  }, [authLoading, roleLoading, user, isAdmin, location.pathname, navigate]);

  return null;
};

export default AdminLockGuard;
